import axios from 'axios';
import { useEffect, useState } from 'react';
import { Account } from '../../authentication/interfaces/Account';
import { getCookie } from '../../common/utils/cookies';
import { apiUrls } from '../../constants';

export const useCurrentAccount = (skip = true): Account | null => {
  const [account, setAccount] = useState<Account | null>(null);

  const fetchCurrentAccount = async (): Promise<void> => {
    try {
      const config = { headers: { sid: getCookie('sid') }, withCredentials: false };
      const { data } = await axios.get(apiUrls.GET_CURRENT_ACCOUNT, config);

      setAccount(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!skip) {
      fetchCurrentAccount();
    }
  }, [skip]);

  return account;
};
